const actions = {
    async list(_, { params }) {
        return await this.getDataStore('/admin/get_log', params);
    }
};
export default {
    namespaced: true,
    actions
};
